module.exports = __webpack_public_path__ + "img/18.6.CODm.ad2272f6.png";